var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("海快倉與一般倉的區別")]),_c('br'),_vm._v(" 海運快遞專區X光機最大可通過兩邊不同時超過180cm的貨物，動線最大承載70kg，因此單件貨物超過70kg或三邊有兩邊超過180cm無法過x光機時，將無法在海快專區通關，此時包裹需轉移至一般倉作為一般海運貨物正式報關進口。因此會產生移倉費、一般倉正式報關費、倉租費、規費等高額通關費用。 "),_c('br'),_c('br'),_vm._v(" *注意，海快倉與一般倉正式報關費用不同： "),_c('br'),_vm._v(" 海快倉正式報關費用200元， "),_c('br'),_vm._v(" 一般倉正式報關費用1800元。 ")])
}]

export { render, staticRenderFns }